import React from 'react';
import Routes from 'apps/portal/routes.erb';
import Link from '@fountain/ui-kit/components/link';
import LayoutHeader from 'shared/layout-header';
import AuthLayout from 'apps/portal/layouts/auth';
import SignInFormContainer from './components/sign-in-form/container';

export default function PortalSignIn() {
  return (
    <AuthLayout
      headerButtons={(
        <LayoutHeader.Button
          href={Routes.new_identity_registration_path()}
          theme="text"
        >
          Sign Up
        </LayoutHeader.Button>
      )}
      title="Sign In"
    >
      <SignInFormContainer />
      <Link href={Routes.new_identity_password_path()}>Forgot Password?</Link>
    </AuthLayout>
  );
}
